import * as React from 'react'
import styles from './footerSoMe-style.css'
import type { LinkViewModel } from '../../view-models/LinkViewModel'
import Image from '../Image/Image'
import Heading from '../Heading/Heading'
import type { ImageViewModel } from '../../view-models/ImageViewModel'
import Link from '../Link/Link'
import Icon from '../Icon/Icon'
import { linkedIn, youtube, facebook } from '../../icons'
import cx from 'classnames'
type Props = {
  soMe?: {
    facebook?: LinkViewModel
    linkedIn?: LinkViewModel
    youtube?: LinkViewModel
  }
  heading?: string
  image?: ImageViewModel
  // @deprecated
  text?: string
  // @internal
  className?: string
}

function FooterSoMe({ soMe, text, heading, image, className }: Props) {
  function getEventMeta(link: LinkViewModel) {
    if (!link) return {}
    return {
      event: 'footer-click',
      eventData: link.label || link.href,
    }
  }

  return (
    <div className={cx(styles.footerSoMe, className)}>
      <div className={styles.footerLogoText}>
        {image && (
          <div className={styles.logoContainer}>
            <Image {...image} contain />
          </div>
        )}
        <div className={styles.soMeContainer}>
          {heading && (
            <Heading className={styles.heading} level={2} tag={'h4'}>
              {heading}
            </Heading>
          )}
          {soMe && (
            <ul className={styles.soMeBlock}>
              {soMe.linkedIn && (
                <li className={styles.soMeItem}>
                  <Link {...soMe.linkedIn} eventMeta={getEventMeta(soMe.linkedIn)}>
                    <Icon display="block" iconSrc={linkedIn} height={'12px'} width={'12px'} />
                  </Link>
                </li>
              )}
              {soMe.facebook && (
                <li className={styles.soMeItem}>
                  <Link {...soMe.facebook} eventMeta={getEventMeta(soMe.facebook)}>
                    <Icon display="block" iconSrc={facebook} height={'12px'} width={'12px'} />
                  </Link>
                </li>
              )}
              {soMe.youtube && (
                <li className={styles.soMeItem}>
                  <Link {...soMe.youtube} eventMeta={getEventMeta(soMe.youtube)}>
                    <Icon display="block" iconSrc={youtube} height={'12px'} width={'12px'} />
                  </Link>
                </li>
              )}
            </ul>
          )}
        </div>
      </div>
    </div>
  )
}

FooterSoMe.displayName = 'FooterSoMe'
FooterSoMe.defaultProps = {}
export default FooterSoMe